export function AcertaLogo({ noText: _ = false }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 694.7 366.3"
      enableBackground="new 0 0 694.7 366.3"
      xmlSpace="preserve"
      role="img"
    >
      <title>Acerta</title>
      <g>
        <g>
          <rect x="95.3" y="256.7" fill="#326DAC" width="71.9" height="14.3" />
          <rect x="166.7" y="256.7" fill="#3C7EC1" width="71.9" height="14.3" />
          <rect x="238" y="256.7" fill="#3694D1" width="71.9" height="14.3" />
          <rect x="309.9" y="256.7" fill="#3EA4DC" width="71.9" height="14.3" />
          <rect x="381.8" y="256.7" fill="#EE3D96" width="71.9" height="14.3" />
          <rect x="453.8" y="256.7" fill="#F47A5C" width="71.9" height="14.3" />
          <rect x="525.3" y="256.7" fill="#FFD400" width="71.9" height="14.3" />
        </g>
        <g>
          <path
            fill="#004A7C"
            d="M186.3,118.8c-1.4,6-2.3,12.3-2.8,18.3l-4.4,53.5h11.1l-1.6,17.9h-31.9c1.2-11.8,3-24,5.8-34.9h-0.7    c-7.5,25.6-21.1,36.7-35.8,36.7c-15.3,0-26.3-10.7-26.3-34.2c0-39.7,23.9-61.1,52.8-61.1c9.3,0,17.6,1.6,24.9,3.9H186.3z     M131.1,189.2c12.1,0,27.9-30,29.3-54.9c-2.8-0.7-6.1-1.4-9-1.4c-17.9,0-27.7,19-27.7,40.5C123.8,183.4,126.4,189.2,131.1,189.2z"
          />
          <path
            fill="#004A7C"
            d="M267.5,204.3c-7.5,4.2-16.3,6-25.3,6c-24.2,0-40.7-12.6-40.7-42.1c0-36.5,22.5-53.2,48.6-53.2    c9.1,0,17.2,1.4,24.4,3.9l-2.1,27.4h-19v-12.3c-0.9-0.7-2.8-1.1-4.6-1.1c-10.2,0-23.2,8.1-23.2,31.9c0,17.2,8.8,25.4,22.6,25.4    c7,0,14.2-2.1,21.4-6L267.5,204.3z"
          />
          <path
            fill="#004A7C"
            d="M348.8,204.3c-8.2,3.9-17.9,6-29,6c-26,0-40.4-12.1-40.4-38.8c0-34.6,19-56.5,49.7-56.5    c20.4,0,29.1,9.7,29.1,22.1c0,17.7-16.7,33.9-54.6,36.7c0.5,12.8,10,16.5,20.2,16.5c10,0,19.7-3.2,28.1-7L348.8,204.3z     M303.7,158.7c23.5-3.2,30.4-10.7,30.4-18.4c0-4.7-3.5-7.4-9-7.4C311.6,132.9,304.7,144.8,303.7,158.7z"
          />
          <path
            fill="#004A7C"
            d="M367,116.7h34c-0.9,9.8-1.9,21.4-4,32.8h0.7c5.8-26.5,18.4-33.7,33.2-33.7c2.1,0,3.7,0.2,5.8,0.9l-3.2,22.3    c-1.2-0.2-2.5-0.4-3.7-0.4c-13.5,0-27.6,8.1-34.7,69.8h-23.2c1.1-9.8,2.3-21.6,2.8-31.2l2.6-42.6h-11.9L367,116.7z"
          />
          <path
            fill="#004A7C"
            d="M459.1,97.1l23.2-1.8l-1.8,21.4H505l-1.6,17.9h-24.6l-2.5,28.1c-0.5,6.3-1.4,14.4-1.4,18.4    c0,6.7,3,9.5,8.3,9.5c5.1,0,10.4-2.3,16.1-4.9l-1.9,19.3c-7,3.2-14,4.6-21.2,4.6c-16.5,0-24.4-8.4-24.4-24.2    c0-4.7,0.9-11.8,1.4-18.6l2.5-32.1h-12.3l1.6-17.9h12.5L459.1,97.1z"
          />
          <path
            fill="#004A7C"
            d="M595.5,118.8c-1.4,6-2.3,12.3-2.8,18.3l-4.4,53.5h11.1l-1.6,17.9h-31.9c1.2-11.8,3-24,5.8-34.9h-0.7    c-7.6,25.6-21.1,36.7-35.8,36.7c-15.3,0-26.3-10.7-26.3-34.2c0-39.7,23.9-61.1,52.8-61.1c9.3,0,17.6,1.6,24.9,3.9H595.5z     M540.4,189.2c12.1,0,27.9-30,29.3-54.9c-2.8-0.7-6.1-1.4-8.9-1.4c-17.9,0-27.7,19-27.7,40.5C533,183.4,535.7,189.2,540.4,189.2z"
          />
        </g>
      </g>
    </svg>
  );
}
